import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatCheckboxModule, MatProgressBarModule, MatTooltipModule } from '@angular/material';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { FcOutlinedSelectComponent } from './fc-outlined-select.component';

@NgModule({
  declarations: [
    FcOutlinedSelectComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,

    MatIconModule,
    MatRippleModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    MatCheckboxModule,
    ScrollingModule,
  ],
  exports: [
    FcOutlinedSelectComponent
  ]
})
export class FcOutlinedSelectModule { }
